export enum RouteDataKey {
  HEADER = 'header',
  FOOTER = 'footer',
  SITE = 'site',
  META = 'meta',
  LINKS = 'links',
  PROJECT_CATEGORIES = 'projectCategories',
  PUBLICATION_CATEGORIES = 'publicationCategories',
}
